import { createContext, useContext } from 'react';
import { useIsRTL } from '../../locale';
const PopoverRootContext = /*#__PURE__*/createContext(undefined);
PopoverRootContext.displayName = 'PopoverRootContext';
export const PopoverRootConsumer = PopoverRootContext.Consumer;
export const PopoverRootProvider = PopoverRootContext.Provider;
let defaultPopoverRoot = null;
/**
 * @param isRTL - defaults to `false`
 * @returns an absolutely positioned div, appended to the body element. Its position is determined by the `isRTL` parameter.
 */
export function getDefaultPopoverRoot(isRTL = false) {
  // NOTE: this div will exist for all tests and will only be created once per environment.
  if (defaultPopoverRoot === null) {
    const root = document.createElement('div');
    // NOTE: our popover root should not be in document flow
    // FIXME: this might be more resilient with `position: fixed` on random pages. Legacy popover
    //      | doesn't used fixed positioning, so that would need to be fixed.

    root.style.position = 'absolute';
    root.style.top = '0px';
    root.style.zIndex = '20';
    document.body.appendChild(root);
    defaultPopoverRoot = root;
  }
  if (isRTL) {
    defaultPopoverRoot.style.removeProperty('left');
    defaultPopoverRoot.style.right = '0px';
  } else {
    defaultPopoverRoot.style.removeProperty('right');
    defaultPopoverRoot.style.left = '0px';
  }
  return defaultPopoverRoot;
}

/**
 * Uses a PopoverRoot context and returns it's value. Defaults to the default popover
 * root if no context exists.
 *
 * Null can be returned when a root is not ready yet. This is useful for first renders.
 */
export function usePopoverRoot() {
  const root = useContext(PopoverRootContext);
  const isRTL = useIsRTL();
  if (root !== undefined) {
    return root;
  } else {
    return getDefaultPopoverRoot(isRTL);
  }
}
//# sourceMappingURL=usePopoverRoot.js.map